import { errorMessage, } from "@lumora/bridge";
import { ViewModel } from "../mvvm/ViewModel.js";
/** Platform-admin per-tenant usage cost table and dry-run month close (#1243). */
export class BillingUsageViewModel extends ViewModel {
    client;
    loadGen = 0;
    constructor(client) {
        super({ period: "", rows: [], loading: false, error: null, closeResult: null, closing: false });
        this.client = client;
    }
    async load(period) {
        const gen = ++this.loadGen;
        this.setState({ loading: true, error: null, closeResult: null });
        try {
            const res = await this.client.getAdminBillingUsage(period);
            if (gen !== this.loadGen)
                return;
            this.setState({ loading: false, period: res.period || period || "", rows: res.rows ?? [] });
        }
        catch (err) {
            if (gen !== this.loadGen)
                return;
            this.setState({
                loading: false,
                rows: [],
                error: errorMessage(err, "Failed to load billing usage."),
            });
        }
    }
    async dryRunClose(period) {
        this.setState({ closing: true, error: null, closeResult: null });
        try {
            const closeResult = await this.client.closeBillingMonth(period, true);
            this.setState({ closing: false, closeResult });
        }
        catch (err) {
            this.setState({ closing: false, error: errorMessage(err, "Dry-run close failed.") });
        }
    }
    totals() {
        const t = { apiCents: 0, r2Cents: 0, storageCents: 0, billedCents: 0 };
        for (const r of this.state.rows) {
            t.apiCents += r.apiCents;
            t.r2Cents += r.r2Cents;
            t.storageCents += r.storageCents;
            t.billedCents += r.billedCents;
        }
        return t;
    }
}
//# sourceMappingURL=BillingUsageViewModel.js.map